import {caseInsensitiveSort} from "../common/Utils";
export const allowanceColumns = [
	{
		name: 'Allowance Date',
		selector: row => row.achEDate,
        sortable: true,
		center: true
	},
	{
		name: 'Payee Name',
		//selector: row => `${row.payeeFirstName.toUpperCase()}  ${row.payeeLastName.toUpperCase()}`,
		selector: row => (`${row?.payeeFirstName ?? ""} ${row?.payeeLastName ?? ""}`.trim().toUpperCase() || "-"),
        sortable: true,
		center: true,
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) =>row.payeeFirstName? row.payeeFirstName: row.payeeLastName ? row.payeeLastName  : ""),
	},
	{
		name: 'Allowance',
		selector: row => row.allowanceUpdate,
		cell: (row) => <span>{row.allowanceUpdate ? row.allowanceUpdate:""}</span>,
        sortable: true,
		wrap: true,
		center: true
	},	
	{
		name: 'Created By',
		selector: row => row.userName,
        sortable: true,
		center: true,
		sortFunction: (rowA, rowB) => caseInsensitiveSort(rowA, rowB, (row) => row.userName? row.userName :""),
	},	
	{
		name: 'Created Date',
		selector: row => row.achDate,
        sortable: true,
		center: true
	 }
];

export const exportAllowanceColumns = [	
	{
		header: 'Allowance Date',
		key: 'achEDate',
	},
	{
		header: 'Payee First Name',
		key: 'payeeFirstName'
	},
	{
		header: 'Payee Last Name',
		key: 'payeeLastName'
	},
	{
		header: 'Allowance',
		key: 'allowanceUpdate'
	},	
	{
		header: "Created By",
		key: 'userName',
	},
	{
		header: "Created Date",
		key: 'achDate',
	}
];
